/** At most three small chips per row; narrow panes preserve the message's width. */
export function reactionFlowLayout(rowWidth: number, counts: readonly number[]) {
  if (!counts.length) return { columns: 0, rows: 0, width: 0 }
  // Include selected borders and the platform emoji glyph's advance width.
  const chipWidth = Math.max(36, ...counts.map(count => 30 + String(count).length * 6))
  const available = Math.max(120, rowWidth || 320)
  const fits = Math.max(1, Math.floor((available * 0.3 + 3) / (chipWidth + 3)))
  const columns = Math.min(3, counts.length, fits)
  return { columns, rows: Math.ceil(counts.length / columns), width: columns * chipWidth + (columns - 1) * 3 }
}
